<div class="modal-body">
  <div class="row">
    <h2>{{ 'brapi-sync.program.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col">
      <form>
        <div class="row pt-2">
          <label for="sourceProgram" class="col-2 col-form-label">{{ 'brapi-sync.program.source-program' | translate }}</label>
          <div class="col-5">
            <app-dropdown-virtual-scroll bindLabel="programName" [(selectedValue)]="context.sourceProgram" [fetchMore]="brapiSourcePrograms"></app-dropdown-virtual-scroll>
          </div>
        </div>
        <div class="row pt-3">
          <label for="targetProgram" class="col-2 col-form-label">{{ 'brapi-sync.program.destination-program' | translate }}</label>
          <div class="col-5">
            <app-dropdown-virtual-scroll bindLabel="programName" [(selectedValue)]="context.targetProgram" [fetchMore]="brapiDestinationPrograms"></app-dropdown-virtual-scroll>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="back()">{{ 'back' | translate }}</button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="!context.sourceProgram?.programDbId || !context.targetProgram?.programDbId">
    @if (loading) {
      <span class="throbber throbber-btn throbber-btn-dark"></span>
    }
    {{ 'next' | translate }}
  </button>
</div>
